/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

/**
 * This file contains typography definitions (not all, just the ones needed for components)
 * to be used within components that have a custom style.
 * This file is useful while we don't have a Typography component.
 */

const typography = (theme) => ({
  body: {
    fontFamily: theme.fontTextRegular,
    fontSize: theme.fontSize3,
    lineHeight: theme.lineHeight4
  },
  caption: {
    fontFamily: theme.fontTextRegular,
    fontSize: theme.fontSize2,
    lineHeight: theme.lineHeight3
  },
  captionSmall: {
    fontFamily: theme.fontTextRegular,
    fontSize: theme.fontSize1,
    lineHeight: theme.lineHeight2
  },
  label: {
    fontFamily: theme.fontTextRegular,
    fontSize: theme.fontSize3,
    lineHeight: theme.lineHeight3
  },
  labelSmall: {
    fontFamily: theme.fontTextRegular,
    fontSize: theme.fontSize1,
    lineHeight: theme.lineHeight2
  },
  subtitleRegular: {
    fontFamily: theme.fontTextRegular,
    fontSize: theme.fontSize5,
    lineHeight: theme.lineHeight5
  }
});

export default typography;
